module.exports = __webpack_public_path__ + "img/20180815_152858_227.11d22704.jpg";